const resourcesTypes = [
  { value: 'monitor', name: 'Moniteur' }
];

export { resourcesTypes };
